export enum PubDateOrderValue {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum FilterReadUnreadValue {
  ALL = '0',
  READ = '1',
  UNREAD = '2'
}
